import React from 'react';

const NotFount = () => {
    return (
        <div>
            <h2>not found</h2>
        </div>
    );
};

export default NotFount;